<script setup lang="ts">
import { Button } from 'pejer/src/components/ui/button'
import { Dialog, DialogContent, DialogTrigger } from 'pejer/src/components/ui/dialog'
import { ref, watch } from 'vue'
import DirectPaymentAccountOnboardingContent from './DirectPaymentAccountOnboardingContent.vue'

const props = defineProps<{
  businessName: string
  organizationId: string
  countryCode: string
  bban: string

  contactPostalCode: string
  contactPersonName: string
  contactPersonEmail: string
}>()

const emits = defineEmits<{
  (e: 'accountCreated'): void
  (e: 'update:finished', value: boolean): void
}>()

const dialogOpen = ref(false)
const closeDialog = () => {
  dialogOpen.value = false
}

const content = ref<InstanceType<typeof DirectPaymentAccountOnboardingContent>>()
watch(dialogOpen, (open) => {
  if (open) content.value?.reset()
})
</script>
<template>
  <Dialog v-model:open="dialogOpen">
    <DialogTrigger as-child>
      <slot>
        <Button @click.prevent.stop variant="default" class="rounded-sm group">
          Last ned direktekonto-avtale
        </Button>
      </slot>
    </DialogTrigger>
    <DialogContent
      class="max-w-[calc(100vw-20px)] max-h-[calc(100vh-50px)] flex flex-col w-[800px] overflow-y-auto"
    >
      <DirectPaymentAccountOnboardingContent
        ref="content"
        v-bind="props"
        @accountCreated="emits('accountCreated')"
        @update:finished="emits('update:finished', $event)"
        @close="closeDialog"
      />
    </DialogContent>
  </Dialog>
</template>
